jQuery(function($) {


      /**********************************/
         /***** HEADER ******/
   /**********************************/


       var viaOHeader = document.querySelector("header.site-header");

      // construct an instance of Headroom, passing the element

      function isNavVisible(viaOHeader) {
        return (viaOHeader.classList.contains('open-s-menu') ? true : false );
      }

         var options = {
             offset : 20,

             // scroll tolerance in px before state changes
          //   tolerance : 0,
             // or you can specify tolerance individually for up/down scroll
             tolerance : {
                 up : 5,
                 down : 0
             },

           onUnpin: function() {
             if ( isNavVisible(viaOHeader) ) {
               this.elem.classList.remove(this.classes.unpinned);
               this.elem.classList.add(this.classes.pinned);
             }
             else {
               this.elem.classList.add(this.classes.unpinned);
               this.elem.classList.remove(this.classes.pinned);
             }
           }
         };

         var headroom  = new Headroom(viaOHeader,options);

         // initialise
         headroom.init();



	  /********************************/
  /* ********* HEADER HOME PAGE GALLERY *******/

  var swiper_TopHome = new Swiper('.swiper-HomeTopGallery', {
     // If we need pagination
       spaceBetween: 0, // try '5%' if you want
       slidesPerView: 1,
       loop: true,
       allowTouchMove: false,
       centeredSlides:false,
       effect: 'fade',
       speed: 1200,
		  fadeEffect: {
		    crossFade: true
		  },
        autoplay: {
           delay: 5500,
           disableOnInteraction: true,
       },

      // pagination: {
      //    el: '.swiper-pagination-headerGallery',
      //    clickable: true
      //  }
   });   



    
    /*******************/
     /* FILTER */
    /*******************/

    var coll = document.getElementsByClassName("collapsible");
    var i;

    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function() {
        this.classList.toggle("active");
        this.parentNode.classList.toggle("active_filters");
        // if(this.parentNode.classList.contains('active_filters')){

        // }
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }
    
        // FORM CONTACT LABEL ///

     $( ".wpcf7-form p.m_move label" ).click(function() {
         $( this ).parent().addClass('focus');
     });

     $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
         $( this ).parent().parent().addClass('focus');
     });

      $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
         if($(this).val() != '') $( this ).parent().parent().addClass('focus');
     });



     /**********************************/
        /***** SELECT ******/
    /**********************************/
      $('#poids').niceSelect();


    /**********************************/
        /***** CHANGEMENT EMPLACEMENT DU PRIX  ******/
    /**********************************/

    $(".variations_form").each(function () {
        const $form = $(this);
        const $price = $form.find(".selected-variation-price");

        // Prix d’une éventuelle variation présélectionnée.
        const initialPrice = $form
            .find(".woocommerce-variation-price")
            .html();

        if (initialPrice) {
            $price.html(initialPrice);
        }

        // Mise à jour lors du choix d’une variation.
        $form.on("show_variation", function (event, variation) {
            $price.html(variation.price_html || "");
        });

        // Suppression lorsque la variation n’est plus sélectionnée.
        $form.on("hide_variation reset_data", function () {
            $price.empty();
        });
    });



      $(document).on("click", ".link_to_scroll", function(e) {
         var item_split = $(this).attr("href");
         var offsetTop = $(item_split).offset().top-50;

          $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 600);
          e.preventDefault();
      });


});


/*********************************************/
/********* Gestion e-commerce / Quantité *******/
/*********************************************/


document.addEventListener("click", function (event) {
    const button = event.target.closest(".quantity__button");

    if (!button) {
        return;
    }

    const quantity = button.closest(".quantity");
    const input = quantity?.querySelector('input.qty[type="number"]');

    if (!input || input.disabled || input.readOnly) {
        return;
    }

    if (button.classList.contains("quantity__button--plus")) {
        input.stepUp();
    }

    if (button.classList.contains("quantity__button--minus")) {
        input.stepDown();
    }

    // Informe WooCommerce et les autres scripts du changement.
    input.dispatchEvent(new Event("input", {
        bubbles: true
    }));

    input.dispatchEvent(new Event("change", {
        bubbles: true
    }));
});

/*********************************************/
/********* Chargement des produits en ajax au click sur une catégorie *******/
/*********************************************/

document.addEventListener("DOMContentLoaded", function () {
    let currentRequest = null;


   function getLocalUrl(url) {
    const parsedUrl = new URL(url, window.location.href);

    return (
        window.location.origin +
        parsedUrl.pathname +
        parsedUrl.search +
        parsedUrl.hash
    );
}
    
function normalizeInternalLinks(container, baseUrl) {
    if (!container) {
        return;
    }

    container.querySelectorAll("a[href]").forEach(function (link) {
        const originalHref = link.getAttribute("href");

        if (!originalHref) {
            return;
        }

        const parsedUrl = new URL(originalHref, baseUrl);

        // Ne modifie pas les liens vers un domaine externe.
        if (parsedUrl.hostname !== window.location.hostname) {
            return;
        }

        link.href =
            window.location.origin +
            parsedUrl.pathname +
            parsedUrl.search +
            parsedUrl.hash;
    });
}


   async function loadShopPage(url, addToHistory = true) {
        const localUrl = getLocalUrl(url);
        const filters = document.querySelector(".shop-category-filters");
        const spinner = filters?.querySelector(".spinner-loader");
        const currentResults = document.querySelector("#shop-results");

        if (!filters || !currentResults) {
            window.location.href = url;
            return;
        }

        // Annule la requête précédente si l’utilisateur clique rapidement.
        if (currentRequest) {
            currentRequest.abort();
        }

        currentRequest = new AbortController();

        filters.setAttribute("aria-busy", "true");

        if (spinner) {
            spinner.hidden = false;
            spinner.setAttribute("aria-hidden", "false");
        }

        currentResults.classList.add("is-loading");

        try {
            const response = await fetch(localUrl, {
                method: "GET",
                headers: {
                    "X-Requested-With": "XMLHttpRequest"
                },
                signal: currentRequest.signal
            });

            if (!response.ok) {
                throw new Error(`Erreur HTTP : ${response.status}`);
            }

            const html = await response.text();
            const parser = new DOMParser();
            const newDocument = parser.parseFromString(html, "text/html");

            const newResults = newDocument.querySelector("#shop-results");
            const newFilters = newDocument.querySelector(
                ".shop-category-filters"
            );

            if (!newResults) {
                throw new Error(
                    "Le conteneur #shop-results est introuvable."
                );
            }

          

            normalizeInternalLinks(newResults, localUrl);
            normalizeInternalLinks(newFilters, localUrl);

            /*
             * Remplace la grille, le compteur, le tri
             * et la pagination en une seule opération.
             */
            currentResults.replaceWith(newResults);

            /*
             * Remplace aussi les filtres afin que WooCommerce/PHP
             * fournisse automatiquement la bonne classe is-active.
             */
            if (newFilters) {
                filters.replaceWith(newFilters);
            }

            // Met à jour le titre de l’onglet.
            document.title = newDocument.title;

            // Met éventuellement à jour le H1 WooCommerce.
            const currentTitle = document.querySelector(
                ".woocommerce-products-header__title.page-title"
            );

            const newTitle = newDocument.querySelector(
                ".woocommerce-products-header__title.page-title"
            );

            if (currentTitle && newTitle) {
                currentTitle.innerHTML = newTitle.innerHTML;
            }

            if (addToHistory) {
                window.history.pushState(
                    { shopAjax: true },
                    "",
                    localUrl
                );
            }

            document.dispatchEvent(
                new CustomEvent("shop:products-updated")
            );
       } catch (error) {
            if (error.name !== "AbortError") {
                console.error("Erreur pendant le filtrage AJAX :", error);
            }
        } finally {
            currentRequest = null;

            const activeFilters = document.querySelector(
                ".shop-category-filters"
            );

            const activeSpinner = activeFilters?.querySelector(
                ".spinner-loader"
            );

            activeFilters?.setAttribute("aria-busy", "false");

            if (activeSpinner) {
                activeSpinner.hidden = true;
                activeSpinner.setAttribute("aria-hidden", "true");
            }

            document
                .querySelector("#shop-results")
                ?.classList.remove("is-loading");
        }
    }

     document.addEventListener("click", function (event) {
        const link = event.target.closest(
            ".shop-category-filter, " +
            ".woocommerce-pagination a"
        );

        if (!link) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        loadShopPage(link.href);
    }, true);


    // Gestion des boutons précédent/suivant du navigateur.
    window.addEventListener("popstate", function () {
        loadShopPage(window.location.href, false);
    });
});

